import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=c45d3cdc"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"
import style0 from "./Servicio.vue?vue&type=style&index=0&id=c45d3cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports